import { Injectable } from '@angular/core';
import { ClassCardConfiguration } from './class-card-configuration';
import { ExamCardConfiguration } from './exam-card-configuration';
import { AssignmentCardConfiguration } from './assignment-card-configuration';
import { CardConfiguration } from './card-configuration';
import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';
import { ExamSessionCardConfiguration } from './exam-session-card-configuration';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { CatalogProductsService } from 'app/core/services/catalog-products.service';
import { Router } from '@angular/router';
import { ConsumableCardConfiguration } from 'app/core/components/workflow-new/course/configurations/consumable-card-configuration';
import { EventCardConfiguration } from './event-card-configuration';
import {MettlExamCardConfiguration} from './mettl-exam-card-configuration';

@Injectable()
export class CardConfigurationService {
  getConf(course): CardConfiguration {
    switch (course.type) {
      case 'class':
        return new ClassCardConfiguration(course, this.certificateService);
      case 'assignment':
        if (course.exam) {
          // throw new Error('Direct Assignment with exams');
          return new ExamCardConfiguration(course, this.translateHandlebarsPipe, this.certificateService);
        } else if (course.productVariant
        && course.productVariant.product && course.productVariant.product.typeKey &&
        'exam' === course.productVariant.product.typeKey.toLowerCase() && course.productVariant.product.externalAssessment){
          return new MettlExamCardConfiguration(course, this.certificateService, this.translateHandlebarsPipe);
        }
        else {
          let res = new AssignmentCardConfiguration(course, this.certificateService, this.translateHandlebarsPipe);
          if (course.productVariant
            && course.productVariant.deliveryFormat &&
            'ebook' === course.productVariant.deliveryFormat.toLowerCase())
            res.links.filter(link => link.text === 'branded.portal.courses.assignment.ebook.download.text')
              .forEach(link => link.text = this.translateHandlebarsPipe.transform(link.text, course));
          return res;
        }
        case 'consumable':
          return new ConsumableCardConfiguration(course, this.catalogProductsService);
      case 'exam':
        return course.assignmentCount > 1 ? new ExamSessionCardConfiguration(course) : new ExamCardConfiguration(course, this.translateHandlebarsPipe, this.certificateService);
      case 'event':
        return new EventCardConfiguration(course, this.catalogProductsService);
      default:
        throw new Error(`Unknown type ${course.type}`);
    }
  }

  getBannerConf(course): CardConfiguration {
    let conf = this.getConf(course);
    conf.links = [];
    conf.clickable = false;
    conf.imageHeight = '200';
    conf.imageWidth = '200';
    conf.cardHeight = '250';
    return conf;
  }

  constructor(private translateHandlebarsPipe: TranslateHandlebarsPipe, private certificateService: CertificateService, private catalogProductsService: CatalogProductsService) { }

}





// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/card-configuration.service.ts